module.exports = __webpack_public_path__ + "static/img/tools_black.e50390ed.svg";